import { Service } from "../Service";

export class EncontrarInmuebles extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description:
          "Compra y venta de casas, departamentos, ph, locales, edificios, terrenos y más. Descubrí y consultá los precios",
        keywords:
          "propiedades, inmuebles, casas, departamentos, alquiler, venta, argenprop",
        title:
          "Encontrá tu casa, departamento, local y el inmueble que necesitás en Argentina.",
        url: "propiedades/encontrar-inmuebles",
        extra: [],
      },
      section: "propiedades",
      sectionAds: "encontrar-inmuebles",
      template: "EncontrarInmuebles",
      title:
        "Encontrá tu casa, departamento, local y el inmueble que necesitás en Argentina.",
      titleHeader: "",
      slug: "propiedades",
      breadcrumb: [
        {
          title: "Propiedades",
          url: "/propiedades",
        },
        {
          title: "Encontrar inmuebles",
          url: "",
        },
      ],
      showTitleHeaderApp: false,
      showMenuApp: false,
      showBreadcrumbApp: true,
      showBannerH1App: false,
    });
  }
}
